import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login', name: '登录', component: () => import('@/views/Login.vue')
    }, {
        path: '/register', name: '注册', component: () => import('@/views/Register.vue')
    }, {
        path: '/404', name: '404', component: () => import('@/views/404.vue')
    },{
        path: '/notification' , name: '通知', component: () => import('@/views/notification.vue')
    }
    /* , {
        path: '/front', name: 'Front', component: () => import('../views/front/Front.vue'),
        children:[
            {
                path: '/frontHome', name: '主页', component: () => import('../views/front/Home.vue')
            },{
                path: '/video', name: '视频', component: () => import('../views/front/Video.vue')
            },{
                path: '/videoDetail', name: '视频详情', component: () => import('../views/front/VideoDetail.vue')
            },{
                path: '/frontArticle', name: '文章列表', component: () => import('../views/front/Article.vue')
            },{
                path: '/articleDetail', name: '文章列表', component: () => import('../views/front/ArticleDetail.vue')
            },
        ]

    } */]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 提供一个重置路由的方法
export const resetRouter = () => {
    router.matcher = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes
    })
}

// 注意：刷新页面会导致页面路由重置
export const setRoutes = () => {
    const storeMenus = localStorage.getItem("menus");
    if (storeMenus) {
        resetRouter()
        // 获取当前的路由对象名称数组
        const currentRouteNames = router.getRoutes().map(v => v.name)
        if (!currentRouteNames.includes('Manage')) {
            // 拼装动态路由
            const manageRoute = {
                path: '/',
                name: '首页',
                component: () => import('@/views/Manage.vue'),
                redirect: "/login",
                children: [
                    {path: 'person', name: '个人信息', component: () => import('@/views/Person.vue')},
                    {path: 'password', name: '修改密码', component: () => import('@/views/Password.vue')}
                ]
            }
            const menus = JSON.parse(storeMenus)
            menus.forEach(menuItem => {
                if (menuItem.pagePath) {  // 当且仅当path不为空的时候才去设置路由
                    let itemMenu = {
                        path: menuItem.path.replace("/", ""),
                        name: menuItem.name,
                        component: () => import('@/views/' + menuItem.pagePath + '.vue'),
                        meta: { title: menuItem.name }  // 使用菜单名称作为 title

                    }
                    manageRoute.children.push(itemMenu)
                } else if (menuItem.children && menuItem.children.length) {
                    let itemMenus = {
                        path: menuItem.path.replace("/", ""),
                        name: menuItem.name,
                        component: () => import('@/views' + menuItem.path+ menuItem.path + '.vue'), 
                        meta: { title: menuItem.name },  // 添加 meta
                        children: []
                    }
                    menuItem.children.forEach(childItem => {
                        if (childItem.path && childItem.pagePath) {
                            let itemMenu = {
                                path: childItem.path.replace("/", ""),
                                name: childItem.name,
                                component: () => import('@/views' + menuItem.path+'/'+ childItem.pagePath + '.vue'),
                                meta: { title: childItem.name }  // 使用子菜单名称作为 title

                            }
                            itemMenus.children.push(itemMenu)
                        }
                    })
                    manageRoute.children.push(itemMenus)
                }
            })
            // 动态添加到现在的路由对象中去
            router.addRoute(manageRoute)
        }
    }
}

// 重置我就再set一次路由
setRoutes()

//路由守卫
router.beforeEach((to, from, next) => {
    localStorage.setItem("currentPathName", to.name) //设置当前路由名称
    store.commit("setPath") //触发store的数据更新
    //未找到路由的情况、
    if (!to.matched.length) {
        const storeMenus = localStorage.getItem("menus")
        if (storeMenus) {
            next("/404") //404
        } else {
            next("/login") // 跳回登录页面
        }
    }
    next() //放行路由
})

export default router
